import { useUser } from '../contexts/UserContext';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import isListingBlurred from '../helpers/isListingBlurred';

export default function useIsListingBlurred(listing: SimpleListing) {
  const { isLoggedIn } = useUser();
  return isListingBlurred(listing, isLoggedIn);
}
